import axios from "axios";

export default axios;